export default __webpack_public_path__ + "static/pole-2-thumb-4a3b10f694d691817bb7f928fc34c9e8.png";